import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { BACKEND_URL } from "../../lib/api";
import { logger } from "../../lib/logger";

const resolveImg = (url) => (url && url.startsWith("/api") ? `${BACKEND_URL}${url}` : url);

export const ArtistOfWeekSection = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api
      .get("/artist-of-the-week")
      .then(({ data }) => setData(data))
      .catch((err) => logger.error("Home AOTW load failed:", err));
  }, []);

  if (!data?.artist) return null;
  const { artist, quote, artworks } = data;
  const preview = (artworks || []).slice(0, 3);

  return (
    <section
      data-testid="home-artist-of-week"
      className="px-6 md:px-12 lg:px-24 py-24 bg-[#111] text-white"
    >
      <div className="grid grid-cols-12 gap-y-10 gap-x-4 lg:gap-10 items-center">
        <div className="col-span-12 lg:col-span-5">
          <div className="aspect-[4/5] overflow-hidden bg-[#222]">
            <img
              src={resolveImg(artist.avatar_url) || "https://images.unsplash.com/photo-1500336624523-d727130c3328?w=800"}
              alt={`${artist.name}, AfricaArtMasters artist of the week${artist.country ? ` — ${artist.country}` : ""}`}
              className="w-full h-full object-cover"
              onError={(e) => {
                e.currentTarget.src = "https://images.unsplash.com/photo-1500336624523-d727130c3328?w=800";
              }}
            />
          </div>
        </div>
        <div className="col-span-12 lg:col-span-7">
          <p className="label-eyebrow text-[#F4C430]">— Artist of the Week</p>
          <h2 className="font-serif-display text-5xl md:text-6xl tracking-tighter font-light mt-4 leading-none">
            {artist.name}
          </h2>
          <p className="label-eyebrow text-[#F4C430]/80 mt-4">{artist.country}</p>
          {quote && (
            <blockquote
              data-testid="aotw-home-quote"
              className="mt-8 border-l-4 border-[#F4C430] pl-6 italic font-serif-display text-2xl leading-snug max-w-xl text-white/90"
            >
              &ldquo;{quote}&rdquo;
            </blockquote>
          )}
          <div className="mt-10 flex gap-4 flex-wrap">
            <Link
              to="/artist-of-the-week"
              data-testid="aotw-home-cta"
              className="label-eyebrow border border-[#F4C430] text-[#F4C430] px-8 py-4 hover:bg-[#F4C430] hover:text-[#111] transition-colors"
            >
              Read the spotlight →
            </Link>
            <Link
              to={`/artist/${artist.id}`}
              className="label-eyebrow border border-white/30 text-white px-8 py-4 hover:bg-white hover:text-[#111] transition-colors"
            >
              Browse works
            </Link>
          </div>
        </div>
      </div>

      {preview.length > 0 && (
        <div className="grid grid-cols-3 gap-4 mt-16 max-w-4xl">
          {preview.map((art) => (
            <Link
              key={art.id}
              to={`/artwork/${art.id}`}
              className="aspect-square overflow-hidden bg-[#222] group"
            >
              <img
                src={resolveImg(art.image_url)}
                alt={`${art.title}${artist?.name ? ` by ${artist.name}` : ""} — original African artwork`}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </Link>
          ))}
        </div>
      )}
    </section>
  );
};

export default ArtistOfWeekSection;
